import { useContext, useEffect, useState, useCallback } from "react";

import { UserContext } from "../../../context/User.context";

import {
  Button,
  Popconfirm,
  QRCode,
  Modal,
  Space,
  Table,
  Tag,
  Input,
  Select,
  Form,
  notification,
  DatePicker,
  Pagination,
} from "antd";
import {
  DeleteOutlined,
  FileDoneOutlined,
  HomeFilled,
  InfoCircleTwoTone,
  InfoCircleFilled,
  DownloadOutlined,
  DeliveredProcedureOutlined,
  UserAddOutlined,
} from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import {
  formatDate,
  formatTimeDate,
  isDatePassed,
} from "../../../utils/DateTime";
import { debounce } from "lodash"; // Menggunakan lodash untuk debounce
import { useHttp } from "../../../utils/DataHendler";
import axios from "axios";
import FileSaver from "file-saver";
import { useMediaQuery } from "react-responsive";

export const JobDashboardList = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 }); //
  const { getData, patchData } = useHttp();
  const { user } = useContext(UserContext);
  const { error, warning } = Modal;
  const { Search } = Input;
  const [form] = Form.useForm();

  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deletedId, setDeletedId] = useState(0);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [dataCategory, setCategory] = useState([]);

  const [filters, setFilters] = useState({}); // State untuk menyimpan filter saat ini

  // LOADING STATE
  const [loadingCategory, setLoadingDeparment] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [data, setData] = useState([]);

  useEffect(() => {
    // getVisitor();
    getCategory();
    fetchData();
  }, [user]);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  // Fungsi untuk mengambil data dari API
  const fetchData = async (queryParams) => {
    setLoading(true);
    try {
      const response = await getData(`/job`, { params: queryParams }, true);
      // const result = await response.json();
      // console.log("DISINI");

      if (response.success) {
        console.log(response.data.data);

        const structuredData = response.data.data.map(
          ({
            id,
            code,
            title,
            department_id,
            job_category_id,
            description,
            image_url,
            requirement,
            created_by,
            updated_by,
            created_at,
            updated_at,
          }) => ({
            key: id,
            id,
            code,
            title,
            department_id,
            job_category_id,
            description,
            image_url,
            requirement,
            created_by,
            updated_by,
            created_at,
            updated_at,
          })
        );
        setData(structuredData);

        console.log(structuredData);
        setPagination({
          page: response.data.pagination.page,
          limit: response.data.pagination.limit,
          total: response.data.pagination.total,
          totalPages: response.data.pagination.totalPages,
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handler untuk perubahan halaman
  const handlePageChange = (newPage) => {
    // fetchData( newPage, pagination.limit);
    handleFilterChange({ page: newPage || 1, limit: pagination.limit });
  };

  const deleteHendler = async (ids) => {
    try {
      await patchData(`/job/${ids}`, {}, {}, true);
      setDeletedId(0);

      // getVisitor();
      await fetchData();
      // message.success(res.data.message);
      api["success"]({
        message: "Delete Successfully ",
        description: "delete success",
      });
    } catch (error) {
      console.log(error);
    }
  };
  // // Fungsi untuk mendapatkan data visitor berdasarkan filter
  // const getVisitor = async (queryParams) => {
  //   setLoading(true);

  //   try {
  //     // Menggunakan axios untuk mengirim request dengan query params dinamis
  //     const response = await getData("/visitor", { params: queryParams }, true);

  //     const structuredData = response.data.map(
  //       ({
  //         id,
  //         name,
  //         approver_id,
  //         approve_at,
  //         created_at,
  //         in_at,
  //         out_at,
  //         code,
  //         verify_at,
  //         status_code,
  //         email,
  //         address,
  //         phone,
  //         active,
  //         institution,
  //         description,
  //         department_name,
  //         appointment,
  //         expired_at,
  //         approver,
  //         verificator,
  //         visitor_time,
  //         card_visitors,
  //       }) => ({
  //         key: id,
  //         product: {
  //           name,
  //         },
  //         codex: {
  //           status_code,
  //         },
  //         code,
  //         verify_at,
  //         status_code,
  //         email,
  //         address,
  //         phone,
  //         active,
  //         institution,
  //         appointment,
  //         expired_at,
  //         created_at,
  //         expandableData: {
  //           id,
  //           card_visitors,
  //           in_at,
  //           out_at,
  //           description,
  //           address,
  //           appointment,
  //           code,
  //           department_name,
  //           approve_at,
  //           expired_at,
  //           approver,
  //           verificator,
  //           visitor_time,
  //         },
  //       })
  //     );

  //     // Set data ke state dan hentikan loading
  //     setDataSource(structuredData);
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // Versi debounce dari getVisitor
  const debouncedGetVisitor = useCallback(
    debounce((newFilters) => {
      // getVisitor(newFilters); // Panggil getVisitor setelah debounce
      fetchData(newFilters);
    }, 900), // Delay 500ms
    []
  );
  // Handler untuk memperbarui filter dan panggil debouncedGetVisitor
  const handleFilterChange = (newFilter) => {
    const updatedFilters = { ...filters, ...newFilter };

    // Hapus filter yang di-set null atau kosong
    Object.keys(updatedFilters).forEach((key) => {
      if (updatedFilters[key] === null || updatedFilters[key] === "") {
        delete updatedFilters[key];
      }
    });

    setFilters(updatedFilters); // Perbarui state filters
    debouncedGetVisitor(updatedFilters); // Panggil versi debounce dari getVisitor
  };

  const getCategory = async () => {
    setLoadingDeparment(true);

    try {
      const response = await getData("/job-category", {}, true);
      setCategory(response.data.data);
      setLoadingDeparment(false);
    } catch (error) {
      setLoadingDeparment(false);
    }
  };

  // const handleOk = async (isApprove = true, idUnApprove) => {
  //   // setModalText("The modal will be closed after two seconds");
  //   // console.log("ADANYA DISINI LO: " + deletedId);
  //   // console.log(user.token);
  //   setConfirmLoading(true);
  //   // setTimeout(() => {

  //   try {
  //     const response = await patchData(
  //       `/visitor/approval/${isApprove ? deletedId : idUnApprove}`,
  //       {
  //         approve: isApprove ? true : false,
  //       },
  //       {},
  //       true
  //     );
  //     setDeletedId(0);
  //     setOpen(false);
  //     setConfirmLoading(false);
  //     // getVisitor();
  //     await fetchData();
  //     // message.success(res.data.message);
  //     isApprove
  //       ? api["success"]({
  //           message: "Approval Successfully Received",
  //           description: "Visitors get approval to enter the area",
  //         })
  //       : api["info"]({
  //           message: "Approval is cancelled",
  //           description: "Visitors are not allowed to enter the area",
  //         });
  //     // console.log(response.data);
  //   } catch (error) {
  //     setDeletedId(0);
  //     setOpen(false);
  //     console.log(error);
  //   }
  // };

  // // Fungsi untuk mengunduh file Excel
  // const downloadExcel = async () => {
  //   setLoading(true);
  //   try {
  //     // Kirim permintaan ke backend untuk mendapatkan file Excel
  //     const response = await axios.post(
  //       "https://lbj-profile-be.vercel.app/visitor/export", // Ganti dengan URL backend Anda
  //       {},
  //       {
  //         responseType: "blob", // Pastikan respons diolah sebagai blob
  //         params: filters,
  //       }
  //     );

  //     // Simpan file menggunakan FileSaver.js
  //     FileSaver.saveAs(new Blob([response.data]), "datavisitor.xlsx");

  //     // Tampilkan notifikasi sukses
  //     api["success"]({
  //       message: "File Excel berhasil diunduh",
  //       description: "File Excel berhasil diunduh",
  //     });
  //   } catch (error) {
  //     console.error("Error downloading Excel:", error);

  //     // Tampilkan notifikasi error
  //     api["error"]({
  //       message: "Gagal mengunduh file Excel.",
  //       description: "Silakan coba lagi atau hubungi administrator.",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Created Job",
      dataIndex: "created_at",
      key: "created_at",
    },
    // {
    //   title: "Pic Number",
    //   dataIndex: "pic_phone",
    //   key: "pic_phone",
    // },
    // {
    //   title: "Pic Email",
    //   dataIndex: "pic_email",
    //   key: "pic_email",
    // },
    // // {
    // //   title: "Code",
    // //   dataIndex: "code",
    // //   key: "code",
    // // },
    // {
    //   title: "Condition",
    //   dataIndex: "active",
    //   key: "active",
    //   render: (_, { active }) => (
    //     <Space>
    //       <Tag
    //         color={
    //           active == "IN" ? "success" : active == "OUT" ? "error" : "warning"
    //         }
    //       >
    //         {active == "IN"
    //           ? "IN"
    //           : active == "OUT"
    //           ? "FINISH"
    //           : "WAITING ROOM"}
    //       </Tag>
    //     </Space>
    //   ),
    // },
    // {
    //   title: "Registration Date",
    //   dataIndex: "created_at",
    //   key: "created_at",
    //   render: (_, { created_at }) => <Space>{formatDate(created_at)}</Space>,
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status_code",
    //   key: "status_code",
    //   render: (_, { codex }) => (
    //     <Space>
    //       <Tag color={codex.status_code == "VERIFIED" ? "success" : "error"}>
    //         {codex.status_code == "VERIFIED" ? "APPROVED" : "UNAPPROVE"}
    //       </Tag>
    //     </Space>
    //   ),
    //   filters: [
    //     {
    //       text: "APPROVED",
    //       value: "VERIFIED",
    //     },
    //     {
    //       text: "UNAPPROVE",
    //       value: "UNVERIFIED",
    //     },
    //   ],
    //   onFilter: (value, record) => {
    //     return record.status_code.indexOf(value) === 0;
    //     // console.log(value);
    //     // console.log(record.status_code);
    //     // return handleFilterChange({ status_code: value || null }); // Perbarui filter
    //   },
    // },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <Button
            icon={<InfoCircleFilled />}
            onClick={() => {
              navigate(`/user/detail-job/${record.id}`);
            }}
          />
          <Button
            icon={<DeleteOutlined color="#EA5B6F" />}
            onClick={() => {
              deleteHendler(record.id);
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <div
        style={{
          marginBottom: "15px",
          display: "flex",
          flexDirection: isMobile ? "column" : "row", // Ubah menjadi kolom jika mobile
          justifyContent: isMobile ? "flex-start" : "space-between", // Sesuaikan alignment
          alignItems: isMobile ? "flex-start" : "center", // Sesuaikan alignment
          gap: isMobile ? "10px" : "0px", // Tambahkan jarak antar elemen jika mobile
        }}
      >
        {/* Bagian Filter */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row", // Ubah menjadi kolom jika mobile
            gap: isMobile ? "10px" : "5px", // Tambahkan jarak antar elemen jika mobile
            width: isMobile ? "100%" : "auto", // Lebar penuh jika mobile
          }}
        >
          {/* Search Filter */}
          <Search
            style={{
              marginRight: isMobile ? "0px" : "5px", // Hapus margin kanan jika mobile
              width: isMobile ? "100%" : "200px", // Lebar penuh jika mobile
            }}
            placeholder="search name or code"
            allowClear
            onChange={(e) => {
              const value = e.target.value.trim();
              handleFilterChange({ search: value || null });
            }}
            onSearch={(value) => {
              handleFilterChange({ search: value.trim() || null });
            }}
            enterButton
          />

          {/* Category Filter */}
          <Select
            disabled={loadingCategory}
            placeholder="Select Category"
            allowClear
            menuItemSelectedIcon={<HomeFilled />}
            onChange={(val) => {
              handleFilterChange({ category_id: val || null });
            }}
            options={dataCategory.map((el) => ({
              value: `${el.id}`,
              label: el.name,
            }))}
            style={{
              width: isMobile ? "100%" : "200px", // Lebar penuh jika mobile
            }}
          />
        </div>

        {/* Tombol Export */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row", // Ubah menjadi kolom jika mobile
            gap: isMobile ? "10px" : "5px", // Tambahkan jarak antar elemen jika mobile
            width: isMobile ? "100%" : "auto", // Lebar penuh jika mobile
          }}
        >
          <Button
            style={{
              marginTop: isMobile ? "10px" : "0px", // Tambahkan margin atas jika mobile
              backgroundColor: "#41B3A2",
              color: "white",
              borderColor: "#41B3A2",
              width: isMobile ? "100%" : "auto", // Lebar penuh jika mobile
            }}
            icon={<UserAddOutlined />}
            onClick={() => {
              navigate(`/user/addjob`);
            }}
            loading={loading}
          >
            Add Job
          </Button>
        </div>
      </div>
      <Table
        dataSource={data}
        columns={columns}
        loading={loading}
        scroll={{
          x: "max-content", // Aktifkan scroll horizontal dengan lebar otomatis
          y: 550,
        }}
        // rowKey={(record) => record.id}
        pagination={false} // Matikan pagination bawaan Ant Design
      />
      {/* Pagination Controls */}
      <Pagination
        current={pagination.page}
        pageSize={pagination.limit}
        total={pagination.total}
        onChange={handlePageChange}
        showSizeChanger={false}
        style={{ marginTop: 20, textAlign: "center" }}
      />
    </>
  );
};
